import { RArray } from "../collections";
export class DateRange {
    constructor(begin, end) {
        if (begin.tz !== end.tz) {
            throw new Error("Date range timezone mismatch");
        }
        this.begin = begin;
        this.end = end;
    }
    get tz() {
        return this.begin.tz;
    }
    includes(date) {
        return date.isBetween(this.begin, this.end);
    }
    intersection(other) {
        const begin = this.begin.isAfter(other.begin) ? this.begin : other.begin;
        const end = this.end.isBefore(other.end) ? this.end : other.end;
        if (begin.isAfter(end)) {
            return null;
        }
        return new DateRange(begin, end);
    }
    get days() {
        const dates = [];
        for (let date = this.begin; date.isBefore(this.end); date = date.add(1, "day")) {
            dates.push(date);
        }
        return new RArray(dates);
    }
    toString() {
        return `${this.begin.toString} - ${this.end.toString}`;
    }
}
